var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// $FlowFixMe
import { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { map } from 'lodash';
import ResizeObserver from 'react-resize-detector';
import api from 'app/core/api/api.js';
import { ModalTrigger, MUIModal, confirmDelete, openModal } from 'app/components/Modal';
import { MUIButton } from 'app/components/Form';
import Widget from 'app/components/Widget/Widget.jsx';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
import resources from 'app/store/resources';
import { Title } from 'app/components/Texts/Title/Title.jsx';
import { ModulableTree } from 'app/components/ModulableTree/ModulableTree.jsx';
import PaginatedComponent from 'app/components/PaginatedComponent/PaginatedComponent.jsx';
import classes from 'app/pages/Admin/Offices/Office/Office.module.scss';
import { permission, Permission } from 'app/containers/Permissions/Permission.jsx';
import AssetsSelect from 'app/containers/Assets/AssetsSelect/AssetsSelect.jsx';
import ModalCreateUser from 'app/pages/Admin/Offices/ModalCreateUser';
import ModalEditOffice from 'app/pages/Admin/Offices/ModalEditOffice';
import { officeByIdSelector } from 'app/store/selectors/offices';
import { deleteOffice } from 'app/store/reducers/offices';
import { officeUsersSelector } from 'app/store/selectors/users';
import { deleteUserFromOffice, fetchOfficeUsers } from 'app/store/reducers/users';
const Office = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { officeId } = useParams();
    const office = useSelector(officeByIdSelector(officeId));
    const allUsers = useSelector(officeUsersSelector(officeId));
    const isLoading = useSelector((state) => state.users.loading);
    const [height, setHeight] = useState(null);
    const [search, setSearch] = useState('');
    const fetchAllUsers = (pageSize, currentPage) => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(fetchOfficeUsers({ officeId, pageSize, currentPage }));
    });
    const onDelete = (user) => {
        confirmDelete({
            title: 'Delete user',
            render: (_jsxs("div", { children: ["Do you want to delete ", _jsx("b", { children: user.name }), " ?"] })),
            validateLabelColor: '#E56D7A',
            validateLabel: 'Delete',
            onValidate: () => dispatch(deleteUserFromOffice(user.id)),
            validateMessage: 'User deleted',
        });
    };
    const replacePlaceholderByUser = (placeholderId) => {
        return openModal(_jsx(MUIModal, { title: "Replace placeholder by user", children: ({ handleClose }) => (_jsx(AssetsSelect, { assetTypes: ['us'], noProjectHeader: true, onChange: (res) => {
                    return api.replacePlaceHolder({ placeHolder: placeholderId, user: res.data && res.data.id }).then(() => {
                        resources.assets.update(Object.assign(Object.assign({}, res.data), { id: placeholderId }), { localOnly: true });
                        handleClose();
                    });
                } })) }));
    };
    const filteredUsers = useMemo(() => {
        return allUsers
            .filter((user) => user.name.includes(search))
            .map((user) => ({
            key: user.id,
            label: user.name.includes(search) ? user.name : null,
            actions: [
                permission(['projet_groups__manage participants']) &&
                    (user === null || user === void 0 ? void 0 : user.name) !== 'all' &&
                    user.assetType === 'ph' && {
                    key: 'Replace placeholder by user',
                    label: _jsx(FontIcon, { icon: "fas-user-check" }),
                    tooltip: 'Replace placeholder by user',
                    onClick: () => replacePlaceholderByUser(user.userInst.id),
                },
                permission(['projet_groups__manage participants']) &&
                    user.assetType !== 'ph' && {
                    key: 'delete',
                    onClick: () => onDelete(user),
                },
            ],
        }));
    }, [search, allUsers]);
    const onDeleteOffice = () => {
        confirmDelete({
            title: 'Delete office',
            render: (_jsxs("div", { children: ["Do you want to delete ", _jsx("b", { children: office === null || office === void 0 ? void 0 : office.name }), " ?"] })),
            validateLabelColor: '#E56D7A',
            validateLabel: 'Delete',
            onValidate: () => __awaiter(void 0, void 0, void 0, function* () {
                yield dispatch(deleteOffice(officeId));
                history.push('/admin/offices/');
            }),
            validateMessage: 'Office deleted',
        });
    };
    const onTitleResize = () => {
        const el = document.querySelector('#ovm-title-offices');
        setHeight(el ? el.offsetHeight + 10 : null);
    };
    if (!office)
        return null;
    return (_jsxs(Widget, { className: classes.areaGroup, style: { width: '100%' }, children: [_jsx(ResizeObserver, { handleWidth: true, onResize: onTitleResize, children: _jsxs("div", { id: "ovm-title-groups", className: "flex column fullWidth", children: [_jsxs("div", { className: classes.usersHead, children: [_jsxs(Title, { size: "3", children: ["Users of ", office === null || office === void 0 ? void 0 : office.name] }), _jsx("input", { className: classes.searchInput, type: "text", onChange: (e) => {
                                        setSearch(e.target.value);
                                    }, placeholder: "Search for a user", value: search })] }), _jsxs("div", { children: [office.name !== 'all' ? (_jsxs(_Fragment, { children: [_jsx(Permission, { actions: ['projet_groups_group_update name'], children: _jsx(ModalTrigger, { modal: _jsx(ModalEditOffice, { office: office }), children: _jsxs(MUIButton, { style: { color: 'grey', fontWeight: 'bolder' }, size: "small", variant: "text", children: [_jsx(FontIcon, { icon: "fas-edit", className: "fontSize14 marginRight5" }), " Edit office name"] }) }) }), _jsx(Permission, { actions: ['projet_groups_group_delete'], children: _jsx(MUIButton, { style: { color: 'grey', fontWeight: 'bolder' }, icon: "fas-trash", size: "small", variant: "text", onClick: onDeleteOffice, children: "Delete office" }) })] })) : null, _jsx(Permission, { actions: ['projet_groups__manage participants'], children: _jsx(ModalTrigger, { modal: _jsx(ModalCreateUser, { officeId: officeId }), children: _jsx(MUIButton, { style: { color: 'grey', fontWeight: 'bolder' }, size: "small", variant: "text", icon: "fas-plus", children: "Create user" }) }) })] })] }) }), _jsx("div", { style: { height: `calc(100% - ${height || 60}px)`, marginTop: 10 }, children: search.length !== 0 ? (_jsx(ModulableTree, { scrollable: true, noItemsLabel: "No users", items: filteredUsers })) : (_jsx(PaginatedComponent, { defaultPageSize: 200, pageSizeOptions: [25, 50, 100, 200, 400], count: 1, style: { height: '100%' }, renderChildren: (res) => {
                        const groupUsers = allUsers;
                        return (_jsx("div", { style: { overflowY: 'auto' }, children: _jsx(ModulableTree, { noItemsLabel: "No users", items: map(groupUsers, (groupUser) => {
                                    var _a, _b;
                                    return ({
                                        key: groupUser === null || groupUser === void 0 ? void 0 : groupUser.id,
                                        label: groupUser === null || groupUser === void 0 ? void 0 : groupUser.name,
                                        actions: [
                                            permission(['projet_groups__manage participants']) &&
                                                office.name !== 'all' &&
                                                ((_a = groupUser.userInst) === null || _a === void 0 ? void 0 : _a.assetType) === 'ph' && {
                                                key: 'Replace placeholder by user',
                                                label: _jsx(FontIcon, { icon: "fas-user-check" }),
                                                tooltip: 'Replace placeholder by user',
                                                onClick: () => replacePlaceholderByUser(groupUser.userInst.id),
                                            },
                                            permission(['projet_groups__manage participants']) &&
                                                ((_b = groupUser.userInst) === null || _b === void 0 ? void 0 : _b.assetType) !== 'ph' && {
                                                key: 'delete',
                                                onClick: () => onDelete(groupUser),
                                            },
                                        ].filter((_) => _),
                                    });
                                }) }) }));
                    }, isLoading: isLoading, onRequestNeeded: fetchAllUsers }, location.pathname)) })] }));
};
export default Office;
